import { AccountPage } from './AccountPage';
import { useStore } from '@/context/StoreContext';
import { navigate } from '@/hooks/useRoute';
export function ContentPage({type}:{type:string}){
 if(type==='account') return <AccountPage/>;const {cms}=useStore();const page=cms.pages[type]||cms.pages.about;const stores=type==='stores';const lead=['appointments','contact'].includes(type);const appointment=type==='appointments';const faq=type==='faq';const heroClass=appointment?' appointment-hero-v713':(page.hero?.editorial?` editorial-hero hero-${page.hero.tone||'dark'} hero-${page.hero.side||'right'}`:'');const heroTitle=appointment?'פגישה אישית. בחירה שמרגישה נכונה.':page.title;
 const openMielleyContactWhatsApp=(e:any)=>{
  e.preventDefault();
  const form=e.currentTarget as HTMLFormElement;
  const fd=new FormData(form);
  const name=String(fd.get('name')||'').trim();
  const phone=String(fd.get('phone')||'').trim();
  const email=String(fd.get('email')||'').trim();
  const subject=String(fd.get('subject')||'').trim();
  const message=String(fd.get('message')||'').trim();
  const lines=[
   'שלום MIELLEY, אשמח לקבל פרטים:',
   '',
   name?`שם: ${name}`:'',
   phone?`טלפון: ${phone}`:'',
   email?`אימייל: ${email}`:'',
   subject?`נושא: ${subject}`:'',
   message?`הודעה: ${message}`:''
  ].filter(Boolean).join('\n');
  const wa=String(cms.site.whatsapp||cms.site.phone||'').replace(/\D/g,'');
  if(wa)window.open(`https://wa.me/${wa}?text=${encodeURIComponent(lines)}`,'_blank','noopener,noreferrer');
 };
 if(type==='contact')return <>
  <nav className="breadcrumbs container"><a href="/" onClick={e=>{e.preventDefault();navigate('/')}}>בית</a><span>›</span><strong>צור קשר</strong></nav>
  <section className="mielley-contact-v1218">
   <aside className="mielley-contact-side">
    <span className="mielley-contact-kicker">MIELLEY · PERSONAL SERVICE</span>
    <h1>נשמח לדבר.</h1>
    <p>שאלה על תכשיט, מידה, מוסונייט או הזמנה? אנחנו כאן כדי לעזור לבחור נכון — בנעימות, בשקיפות ובלי לחץ.</p>
    <div className="mielley-contact-methods">
     <a href={`https://wa.me/${String(cms.site.whatsapp||cms.site.phone||'').replace(/\D/g,'')}`} target="_blank" rel="noreferrer">
      <i>✦</i><span><b>WhatsApp</b><small>הדרך המהירה ביותר לדבר איתנו</small></span><em>←</em>
     </a>
     <a href={`tel:${cms.site.phone}`}>
      <i>☎</i><span><b>{cms.site.phone}</b><small>לשיחה אישית עם MIELLEY</small></span><em>←</em>
     </a>
     {cms.site.email&&<a href={`mailto:${cms.site.email}`}>
      <i>✉</i><span><b>{cms.site.email}</b><small>נשמח לחזור אליכם במייל</small></span><em>←</em>
     </a>}
    </div>
    <div className="mielley-contact-tagline">LOOK EXPENSIVE. THINK SMART.</div>
   </aside>

   <div className="mielley-contact-form-wrap">
    <span>LET'S TALK</span>
    <h2>איך אפשר לעזור?</h2>
    <p>השאירו כמה פרטים וההודעה תיפתח אצלנו ישירות ב־WhatsApp.</p>
    <form className="mielley-contact-form" onSubmit={openMielleyContactWhatsApp}>
     <label>שם מלא<input name="name" required placeholder="השם שלכם"/></label>
     <label>טלפון<input name="phone" required inputMode="tel" placeholder="050-0000000"/></label>
     <label>אימייל<input name="email" type="email" placeholder="name@email.com"/></label>
     <label>נושא
      <select name="subject" defaultValue="שאלה על תכשיט">
       <option>שאלה על תכשיט</option>
       <option>מידות והתאמה</option>
       <option>הזמנה קיימת</option>
       <option>משלוחים והחזרות</option>
       <option>אחר</option>
      </select>
     </label>
     <label className="full">במה נוכל לעזור?<textarea name="message" rows={5} placeholder="כתבו לנו בקצרה מה אתם מחפשים..."/></label>
     <button className="mielley-contact-submit" type="submit">שליחה ל־WhatsApp ←</button>
     <p className="mielley-contact-note">בלחיצה על שליחה תיפתח הודעת WhatsApp עם הפרטים שמילאתם.</p>
    </form>
   </div>
  </section>
 </>;

 if(type==='shipping') return <>
  <nav className="breadcrumbs container">
    <a
      href="/"
      onClick={e=>{
        e.preventDefault();
        navigate('/');
      }}
    >
      בית
    </a>
    <span>›</span>
    <strong>משלוחים, החזרות והחלפות</strong>
  </nav>

  <section className="section">
    <div className="container narrow content-copy" dir="rtl">

      <span style={{
        display:'block',
        marginBottom:12,
        letterSpacing:'3px',
        fontSize:13,
        fontWeight:700
      }}>
        MIELLEY · DELIVERY & RETURNS
      </span>

      <h1>משלוחים, החזרות והחלפות</h1>

      <p>
        כל מה שחשוב לדעת מרגע ההזמנה ועד קבלת התכשיט,
        החזרה, החלפה או טיפול במקרה של פגם — בשקיפות
        ובכפוף לזכויות הצרכן לפי הדין.
      </p>

      <hr/>

      <h2>פרטי מפעיל האתר</h2>

      <p>
        MIELLEY — מופעל על ידי מיכה לסרי,
        מס׳ עוסק/זיהוי 031755705.
      </p>

      <p>
        כתובת: רפאלי שרגא 9, פתח תקווה.
      </p>

      <p>
        דוא״ל:{' '}
        <a href="mailto:mielley.jw@gmail.com">
          mielley.jw@gmail.com
        </a>
        {' · '}
        טלפון:{' '}
        <a href="tel:0556649480">
          055-6649480
        </a>
      </p>

      <p>
        הכתובת אינה בהכרח נקודת קבלת קהל או החזרת מוצרים
        ללא תיאום מראש.
      </p>

      <hr/>

      <h2>1. אזורי משלוח ואפשרויות אספקה</h2>

      <p>
        MIELLEY מספקת הזמנות לכתובות ולאזורי מסירה בהתאם
        לאפשרויות הזמינות בעת ביצוע ההזמנה. אפשרויות המשלוח,
        עלותן והערכת זמן האספקה יוצגו ללקוח באתר, בקופה או
        באישור ההזמנה, לפי העניין.
      </p>

      <p>
        אם מוצגת באתר הטבת משלוח חינם מעל סכום קנייה מסוים,
        ההטבה תחול בהתאם לתנאים המוצגים בזמן ההזמנה,
        לאחר קיזוז קופונים או החזרות ככל שנדרש.
      </p>

      <hr/>

      <h2>2. זמני הכנה ואספקה</h2>

      <p>
        מועד האספקה המחייב הוא המועד שנמסר ללקוח במסגרת
        העסקה, בכפוף לדין. זמן האספקה עשוי לכלול זמן הכנה
        של התכשיט וזמן הובלה על ידי חברת השילוח.
      </p>

      <p>
        מוצר במלאי עשוי להישלח מהר יותר ממוצר הדורש מידה,
        התאמה, חריטה, שינוי או הכנה מיוחדת.
      </p>

      <p>
        שבתות, חגים, ערבי חג, מצב ביטחוני, מזג אוויר קיצוני,
        עומסים חריגים או אירועים שאינם בשליטת MIELLEY עשויים
        להשפיע על זמני השילוח.
      </p>

      <hr/>

      <h2>3. כתובת, פרטי קשר וניסיון מסירה</h2>

      <p>
        באחריות הלקוח למסור שם, טלפון, כתובת ופרטי מסירה
        נכונים ומלאים. טעות בפרטים עלולה לגרום לעיכוב
        או למשלוח חוזר.
      </p>

      <hr/>

      <h2>4. קבלת החבילה ובדיקת המוצר</h2>

      <p>
        עם קבלת המשלוח מומלץ לבדוק שהחבילה והתכשיט הגיעו
        תקינים ותואמים להזמנה. במקרה של מוצר שגוי, חוסר,
        נזק או פגיעה נראית לעין באריזה, מומלץ לפנות אלינו
        בהקדם.
      </p>

      <hr/>

      <h2>5. ביטול עסקת מכר מרחוק והחזרת מוצר</h2>

      <p>
        רכישה באתר היא בדרך כלל עסקת מכר מרחוק. בהתאם
        לחוק הגנת הצרכן, קיימת לצרכן, בכפוף לתנאי החוק
        ולחריגיו, זכות לבטל עסקה לרכישת מוצר בתוך התקופה
        הקבועה בדין — בדרך כלל עד 14 ימים מהמועד הקובע
        לפי החוק.
      </p>

      <p>
        במקרים שבהם הדין מעניק תקופת ביטול מורחבת,
        נפעל בהתאם לזכות המורחבת.
      </p>

      <p>
        עצם פתיחת האריזה או בדיקה סבירה של המוצר אינן
        שוללות בהכרח את זכות הביטול. עם זאת, אם נגרם
        למוצר נזק או ירידת ערך עקב שימוש שאינו נדרש
        לבדיקה סבירה, עשויות לחול הוראות הדין הרלוונטיות.
      </p>

      <hr/>

      <h2>6. דמי ביטול ועלות החזרת המוצר</h2>

      <p>
        כאשר ביטול העסקה אינו עקב פגם, אי־התאמה,
        אי־אספקה במועד או הפרה אחרת המזכה את הצרכן
        לפי דין, ניתן לגבות דמי ביטול רק בשיעור המותר
        בחוק — בדרך כלל עד 5% ממחיר העסקה או 100 ₪,
        לפי הנמוך.
      </p>

      <p>
        בביטול רגיל שאינו עקב פגם או אי־התאמה,
        האחריות והעלות להחזרת המוצר לעסק עשויות
        לחול על הלקוח בהתאם לדין.
      </p>

      <hr/>

      <h2>7. מוצר פגום, מוצר שגוי או אי־התאמה</h2>

      <p>
        אם התקבל מוצר פגום, שגוי או שאינו תואם את פרטי
        העסקה, פנו אלינו ל־
        <a href="mailto:mielley.jw@gmail.com">
          mielley.jw@gmail.com
        </a>
        {' '}או בטלפון{' '}
        <a href="tel:0556649480">
          055-6649480
        </a>
        , בצירוף מספר ההזמנה ותיאור הבעיה.
      </p>

      <p>
        נבדוק את המקרה ונציע פתרון מתאים — תיקון,
        החלפה, אספקת מוצר תואם, ביטול והשבה או פתרון אחר,
        בהתאם לנסיבות ולזכויות הקבועות בדין.
      </p>

      <hr/>

      <h2>8. החלפת מידה או דגם</h2>

      <p>
        בקשה להחלפת מידה או דגם שאינה נובעת מפגם
        תטופל בהתאם לזמינות מלאי, מצב המוצר והוראות הדין.
      </p>

      <p>
        לפני שליחת מוצר להחלפה יש ליצור קשר עם MIELLEY
        ולקבל הנחיות. אין לשלוח תכשיט לכתובת העסק
        ללא תיאום.
      </p>

      <hr/>

      <h2>9. מוצרים שיוצרו או הותאמו במיוחד</h2>

      <p>
        מוצר שיוצר, נחרט, שונה או הותאם במיוחד לפי מידות
        או דרישות ייחודיות של הלקוח עשוי להיות כפוף
        להסדרי ביטול שונים. החרגה מזכות הביטול תחול
        רק ככל שמתקיימים התנאים שנקבעו בדין.
      </p>

      <hr/>

      <h2>10. מצב המוצר בעת החזרה</h2>

      <p>
        יש להחזיר את התכשיט כשהוא מוגן היטב ובצירוף
        הפריטים שנמסרו עמו ככל שניתן.
      </p>

      <p>
        מומלץ להשתמש באריזה קשיחה ובשיטת משלוח
        הניתנת למעקב כאשר האחריות להחזרה מוטלת
        על הלקוח.
      </p>

      <hr/>

      <h2>11. החזר כספי</h2>

      <p>
        כאשר קיימת זכאות להשבה, MIELLEY תשיב את הסכום
        במועד ובאופן הקבועים בדין. בעסקת מכר מרחוק,
        הדין קובע במקרים הרלוונטיים השבה בתוך 14 ימים
        ממועד קבלת הודעת הביטול.
      </p>

      <hr/>

      <h2>12. החזרה בדואר או באמצעות חברת שילוח</h2>

      <p>
        לפני החזרה יש לפנות אלינו ולקבל כתובת והנחיות
        עדכניות. הכתובת הרשומה של העסק היא
        רפאלי שרגא 9, פתח תקווה, אך אין לשלוח אליה
        תכשיט ללא תיאום ואישור מאיתנו.
      </p>

      <hr/>

      <h2>13. אובדן או נזק במהלך משלוח</h2>

      <p>
        אם משלוח אל הלקוח אבד או ניזוק לפני מסירתו,
        יש לפנות אלינו ונבדוק את האירוע מול חברת השילוח.
        זכויות הצדדים ייקבעו בהתאם לדין ולנסיבות המסירה.
      </p>

      <hr/>

      <h2>14. אחריות ותיקון לאחר תקופת ההחזרה</h2>

      <p>
        בקשה הנוגעת לפגם ייצור או אחריות אינה זהה לבקשת
        ביטול רגילה. אם חלפה תקופת הביטול אך קיימת טענת
        פגם, אחריות או אי־התאמה, פנו אלינו ונבדוק
        את המקרה.
      </p>

      <hr/>

      <h2>15. איך מתחילים החזרה או ביטול</h2>

      <p>
        <strong>1. פונים אלינו</strong><br/>
        עם מספר ההזמנה ומה מבקשים לבצע.
      </p>

      <p>
        <strong>2. מקבלים הנחיות</strong><br/>
        נעדכן אם נדרש משלוח חזרה, איסוף או פעולה אחרת.
      </p>

      <p>
        <strong>3. בדיקה וטיפול</strong><br/>
        לאחר קבלת המוצר או המידע נבצע את הטיפול המתאים.
      </p>

      <p>
        <strong>4. החלפה או החזר</strong><br/>
        בהתאם לבקשה, למלאי ולזכאות לפי דין.
      </p>

      <hr/>

      <h2>16. יצירת קשר</h2>

      <p>
        שירות לקוחות MIELLEY:{' '}
        <a href="mailto:mielley.jw@gmail.com">
          mielley.jw@gmail.com
        </a>
        {' · '}
        <a href="tel:0556649480">
          055-6649480
        </a>
      </p>

      <p>
        מפעיל האתר: מיכה לסרי, מס׳ עוסק/זיהוי 031755705,
        רפאלי שרגא 9, פתח תקווה.
      </p>

      <p>
        הוראות מדיניות זו כפופות לדין. במקרה של סתירה
        בין המדיניות לבין הוראה קוגנטית בחוק —
        הוראת החוק גוברת.
      </p>

      <p>
        <strong>עדכון אחרון: 26.08.2026</strong>
      </p>

    </div>
  </section>
</>;

 if(type==='about')return <>
  <nav className="breadcrumbs container"><a href="/" onClick={e=>{e.preventDefault();navigate('/')}}>בית</a><span>›</span><strong>אודות</strong></nav>
  <section className="mielley-about-story-v1217" aria-label="הסיפור של MIELLEY">
   <img src="/assets/mielley-about-story-v1217.png" alt="MIELLEY — תכשיטי מוסונייט וכסף 925"/>
   <div className="mielley-about-story-a11y">
    <h1>אודות MIELLEY</h1>
    <p>MIELLEY נולדה מתוך אהבה לתכשיטים שנראים יוצאי דופן — בלי לשלם מחיר מיותר.</p>
    <p>אנחנו מתמחים בתכשיטי מוסונייט וכסף 925, עם דגש על עיצוב אלגנטי, איכות גבוהה ובחירה חכמה.</p>
    <p>כל תכשיט נבחר בקפידה כדי להעניק ברק, נוכחות ותחושה יוקרתית שמתאימה לכל יום ולכל רגע מיוחד.</p>
   </div>
  </section>
  <section className="mielley-about-trust-v1217" aria-label="הערכים של MIELLEY">
   <article><span>MOISSANITE</span><b>ברק שנבחר בקפידה</b><small>מראה יוקרתי ונוכחות מרשימה</small></article>
   <article><span>925 SILVER</span><b>כסף סטרלינג 925</b><small>בסיס איכותי לתכשיט שנועד להישאר</small></article>
   <article><span>MIELLEY</span><b>בחירה חכמה יותר</b><small>LOOK EXPENSIVE. THINK SMART.</small></article>
  </section>
 </>;
 return <>
<nav className="breadcrumbs container"><a href="/" onClick={e=>{e.preventDefault();navigate('/')}}>בית</a><span>›</span><strong>{page.title}</strong></nav>
<section className={`content-hero${heroClass}`}><img src={page.image} alt={page.title}/><div><span>{page.eyebrow}</span><h1>{heroTitle}</h1><p>{page.intro}</p>{appointment&&<a className="appointment-hero-cta" href="#appointment-form">לתיאום פגישה ←</a>}</div></section>
<section className="section"><div className="container narrow content-copy"><h2>{page.title}</h2><p>{page.intro}</p><p>החוויה של MIELLEY בנויה סביב מידע ברור, עיצוב מדויק וליווי אנושי. אפשר להתחיל באתר ולהמשיך בפגישה אישית, או להפך.</p>
{stores&&<div className="store-grid">{[['תל אביב','סטודיו MIELLEY · בתיאום מראש'],['רמת גן','אולם תצוגה · אזור הבורסה'],['פגישה דיגיטלית','שיחת וידאו אישית מכל מקום']].map(([city,detail])=><article key={city}><span>{city}</span><h3>{detail}</h3><p>ייעוץ, מדידה, השוואת יהלומים והתאמת תכשיט.</p><a href="/appointments" onClick={e=>{e.preventDefault();navigate('/appointments')}}>תיאום פגישה ←</a></article>)}</div>}
{lead&&<form id={appointment?'appointment-form':undefined} className="lead-form" onSubmit={e=>e.preventDefault()}><div className="form-grid"><label>שם מלא<input required/></label><label>טלפון<input required/></label><label>אימייל<input type="email"/></label><label>סוג הפגישה<select><option>פגישה באולם התצוגה</option><option>שיחת וידאו</option><option>שיחה טלפונית</option></select></label><label className="full">מה תרצו לחפש?<textarea rows={4}/></label></div><button className="btn gold">שליחה</button></form>}
{faq&&<div className="faq-list">{['האם יהלום מעבדה הוא יהלום אמיתי?','איך בוחרים מידת טבעת?','כמה זמן לוקח להכין תכשיט?','האם אפשר להחזיר או להחליף?','האם מצורפת תעודה?','האם אפשר לבצע עיצוב אישי?'].map((q,i)=><details key={q} open={i===0}><summary>{q}</summary><p>כן. צוות MIELLEY יציג את כל הנתונים והאפשרויות בהתאם לדגם, לאבן ולמדיניות הרכישה.</p></details>)}</div>}
</div></section></>}
